import React from 'react';
import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import { MoveToBatchModal } from '../../components/modals/move-to-batch-modal';
import * as HeaderActions from '../../store/orders/grid/orders.grid.header.actions';
import * as BatchActions from '../../store/batches/batches.actions';
import { loadMoreActiveBatches } from '../../store/batches/nav/batches.nav.actions';
import { FormattedMessage } from 'react-intl';
import { getBatchListsFromState } from './get-batch-collections-from-state';

const addToBatchHeader = () => {
  return <FormattedMessage defaultMessage='Add to Batch' description='ordersGridAddToBatchModal.header' id='inqq5p' />;
};

const mapStatesToProps = (state) => {
  const { myBatches, otherBatches } = getBatchListsFromState(state);
  const hasFetchedActiveBatches = Global.selectBatchesNavHasFetchedActiveBatches(state);
  const selectedSalesOrderIds = Global.selectSelectedOrdersIds(state);
  const alternateHeader = addToBatchHeader();
  const users = Global.selectSellerUsers(state);
  const currentUserId = Global.selectUserCurrentUserId(state);
  const selectedUser = users.find((user) => user.userId === currentUserId);
  const pageSize = Global.selectBatchesNavPageSize(state);
  const totalBatchesCount = Global.selectBatchesNavTotalBatchesCount(state);
  const shouldShowLoadMoreButton = pageSize < totalBatchesCount;

  return {
    isLoading: !hasFetchedActiveBatches,
    myBatches,
    otherBatches,
    alternateHeader,
    selectedSalesOrderIds,
    assignedUser: selectedUser,
    shouldShowLoadMoreButton,
  };
};

const dispatchProps = (dispatch) => {
  return {
    moveToBatch: (fulfillmentPlanSetId, filters) => {
      dispatch(HeaderActions.addSalesOrderToBatchFromOrderGrid(fulfillmentPlanSetId, filters));
    },
    createBatch: (assignToUserId, fulfillmentPlanIds, name = '', filters) => {
      dispatch(BatchActions.createBatchWithFulfillmentPlans(name, assignToUserId, fulfillmentPlanIds, false, filters));
    },
    loadMore: () => dispatch(loadMoreActiveBatches()),
  };
};

export const OrdersGridMoveToBatchModalContainer = connect(mapStatesToProps, dispatchProps)(MoveToBatchModal);
